import {createRouter, createWebHistory} from '@ionic/vue-router';
import {RouteLocation, RouteLocationNormalized, RouteRecordRaw, routeLocationKey} from 'vue-router';
import Home from '../views/Home.vue'
import Login from "@/views/auth/Login.vue";
import Register from "@/views/auth/Register.vue";
import ForgotPassword from "@/views/auth/ForgotPassword.vue";
import Goals from "@/views/majors/Goals.vue";
import Reviews from "@/views/majors/Reviews.vue";
import Tools from "@/views/majors/Tools.vue";
import TaskForm from "@/components/TaskForm.vue";

import firebase from "firebase";

import { inject } from 'vue';
import Init from "@/views/Init.vue";
import ReviewForm from "@/components/ReviewForm.vue";
import Tool from "@/views/minors/Tool.vue";
import Stats from "@/views/minors/Stats.vue";
import Legal from "@/views/Legal.vue";

const routes: Array<RouteRecordRaw> = [
    {
        path: '/',
        component: Init,
        meta:{
            public:true
        }
    },
    {
        path: '/overview/',
        name: 'Home',
        component: Home,
        children: [
            {
                path: '',
                redirect: 'timeline'
            },
            {
                path: 'timeline/',
                name: 'Timeline',
                component: () => import("@/views/majors/Timeline.vue"),

            },
            {
                path: 'goals/',
                name: 'Goals',
                component: Goals,

            },
            {
                path: 'reviews/',
                name: 'Reviews',
                component: Reviews,

            },
            {
                path: 'tools/',
                name: 'Tools',
                component: Tools,

            }
        ]
    },
    {
        path: '/task/new/',
        name: 'NewTask',
        component: TaskForm
    },
    {
        path: '/tool/:toolId/',
        name: 'Tool',
        props:true,
        component: Tool
    },
    {
        path: '/task/edit/:taskId/',
        name: 'EditTask',
        props:
            (route: RouteLocationNormalized) => {
                const realRoute = inject(routeLocationKey);
                console.log("route",realRoute?.params["taskId"]);
                return {
                    taskId:realRoute?.params["taskId"]
                }
            },
        component: TaskForm
    },
    {
        path: '/review/new/:tasks',
        name: 'NewReview',
        component: ReviewForm,
        props: true
    },
    {
        path: '/review/edit/:reviewId/',
        name: 'EditReview',
        props:
            (route: RouteLocationNormalized) => {
                const realRoute = inject(routeLocationKey);
                console.log("route",realRoute?.params["reviewId"]);
                return {
                    reviewId:realRoute?.params["reviewId"]
                }
            },
        component: ReviewForm
    },
    {
        path: '/login/',
        name: 'Login',
        component: Login,
        meta:{
            public:true
        }
    },
    {
        path: '/register/',
        name: 'Register',
        component: Register,
        meta:{
            public:true
        }
    },
    {
        path: '/forgotpassword/',
        name: 'ForgotPassword',
        component: ForgotPassword,
        meta:{
            public:true
        }
    },
    {
        path: '/legal/',
        name: 'Legal',
        component: Legal,
        meta:{
            public:true,
            private:true
        }
    },
    {
        path: '/legal/',
        name: 'Legal',
        component: Legal,
        meta:{
            private:true,
            public:true
        }
    },
    {
        path: '/stats/',
        name: 'Stats',
        component: Stats
    }

]

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes
})

router.beforeEach((to, from, next) => {
    const currentUser = firebase.auth().currentUser
    const requiresAuth = to.matched.some(record => !record.meta.public)
    const doesNotRequireAuth = to.matched.some(record => record.meta.private)

    console.log("loginstate",currentUser,requiresAuth,doesNotRequireAuth);
    if(!requiresAuth && doesNotRequireAuth) next()
    else if (requiresAuth && !currentUser) next('/')
    else if (!requiresAuth && currentUser) next({name:'Timeline'})
    else  next()

})

export default router
